/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CancelAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function CancelAction({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Email/Emails/Content/Email/Edit/Content/CancelAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../No'))}
 marginRight={dtSpaceXs}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Cancel"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}